<template>
  <v-progress-circular v-if="loading" indeterminate color="primary" />
  <div v-else class="d-flex gap-1">
    <div class="d-flex flex-column">
      <info-tooltip
        v-if="fetchError"
        bottom
        :tooltip-text="fetchError"
        icon="mdi-alert-circle-outline"
        icon-color="red"
      />
      <template v-else>
        <info-tooltip
          bottom
          tooltip-text="Población"
          icon="mdi-account-supervisor-circle"
          icon-color="#218838"
        />
        <info-tooltip
          bottom
          :tooltip-text="`${populationCountFormated} h`"
          :text="`${textTruncate(populationCountFormated, 10, '..')} h`"
          item-class="text-caption"
        />
      </template>
    </div>

    <div v-if="!fetchError" class="d-flex flex-column">
      <info-tooltip
        bottom
        tooltip-text="Venta por habitante"
        icon="mdi-account-multiple-check-outline"
        icon-color="primary"
      />
      <info-tooltip
        bottom
        :tooltip-text="`${salesPerCapita} $/h`"
        :text="`${textTruncate(`${salesPerCapita} $/h`, 11, '..')}`"
        item-class="text-caption"
      />
    </div>
  </div>
</template>

<script>
  import numbersFormats from '@/mixins/numbersFormats';
  import MixinHelpers from '@/mixins/helpers';
  import InfoTooltip from '@/components/tooltips/InfoTooltip.vue';
  import axios from '@/plugins/axios';

  const validScope = ['manager', 'director', 'territorial'];

  export default {
    name: 'SalesPerCapita',
    components: {
      InfoTooltip,
    },
    mixins: [numbersFormats, MixinHelpers],
    props: {
      chnl: {
        type: String,
        required: true,
      },
      userCode: {
        type: [String, Number],
        required: true,
      },
      scope: {
        type: String,
        required: true,
        validator: (value) => validScope.includes(value),
      },
      billedAmount: {
        type: Number,
        required: true,
      },
    },
    data: () => ({
      populationCount: 0,
      loading: false,
      fetchError: '',
    }),
    computed: {
      salesPerCapita() {
        if (this.billedAmount > 0 && this.populationCount) {
          return this.formatNumberOptionalDecimals(
            this.billedAmount / this.populationCount,
            '',
            0
          );
        }
        return 0;
      },
      populationCountFormated() {
        return this.formatNumber(this.populationCount, '', 0);
      },
    },
    mounted() {
      this.fetchPopulation();
    },
    methods: {
      async fetchPopulation() {
        this.loading = true;
        try {
          const response = await axios.get(`/citizens/${this.scope}`, {
            params: {
              channel: this.chnl,
              user: this.userCode,
            },
          });
          this.populationCount = response.data;
        } catch (error) {
          this.fetchError =
            'No se ha podido cargar la información de población correctamente. Por favor intente de nuevo más tarde.';
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
